<template>
  <div class="py-7 container-fluid">
    <div class="card">
      <div class="card-header pb-0">
        <div class="mb-3">
          <h6 v-if="stacks.length === 0">Stacks not found</h6>
          <h6 v-else>Stacks</h6>
          <router-link
            class="btn btn-primary btn-sm"
            :to="{
              name: 'StackAdd',
            }"
            >Add</router-link
          >
        </div>
        <div class="input-group">       
            <div class="form-outline" data-mdb-input-init>
              <label for="exampleFormControlInput1" class="form-label"
          >Buscar por nombre o proyecto</label>
              <input
                type="search"
                id="form1"
                class="form-control"
                placeholder="Search by name"
                v-model="searchStackSelected"
                @input="searchStack(searchStackSelected)"
              />
              <label class="form-label" for="form1"> </label>
            </div>
          </div>         
      </div>
      <div class="row">
        <div class="table-responsive p-0">
          <table class="table align-items-center justify-content-center mb-0">
            <div class="col-lg-10">
              <div class="row mt-4">
                <div class="row">
                  <div class="col-lg-3 col-md-6 col-12" v-for="stack in stacks" :key="stack.name">
  <div class="card shadow-sm border-0 rounded-4 p-3 m-3 h-100">
    <div class="card-body d-flex flex-column justify-content-between h-100">
      <div>
        <h6 class="text-primary fw-bold mb-2">
          <i class="bi bi-stack"></i> {{ stack.name }}
        </h6>
        <h6 class="text-primary fw-bold mb-2">
          <i class="bi bi-folder2-open"></i> {{ stack.namespace.name }}
        </h6>

        <div class="mb-2 small text-muted">
          <argon-badge variant="fill" size="md" color="secondary" class="me-1 mb-1">
            {{ stack.timezone }}
          </argon-badge>
          <argon-badge variant="fill" size="md" color="secondary" class="me-1 mb-1">
            {{ stack.imageStack.name }}
          </argon-badge>
          <argon-badge variant="fill" size="md" color="secondary" class="mb-1">
            {{ stack.machine.name }} ({{ stack.machine.memory }} x {{ stack.machine.cpu }})
          </argon-badge>
        </div>
      </div>

      <div class="mt-3 d-flex flex-column gap-2">
        <router-link
          class="btn btn-outline-primary btn-sm w-100"
          :to="{ name: 'StackUpdate', params: { id: stack.ID } }"
        >
          <i class="bi bi-pencil-fill"></i> Edit
        </router-link>

        <a href="#" @click="createSnapshot(stack)" class="btn btn-outline-secondary btn-sm w-100">
          <i class="bi bi-archive-fill"></i> Create snapshot
        </a>

        <a
          href="#"
          data-bs-toggle="modal"
          :data-bs-target="'#stackTemplate-' + stack.ID"
          class="btn btn-outline-dark btn-sm w-100"
        >
          <i class="bi bi-gear-fill"></i> Create template
        </a>
        <div
        class="modal fade"
        :id="'stackTemplate-' + stack.ID"
        tabindex="-1"
        aria-labelledby="ModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog">
          <form @submit.prevent="createTemplate(stack)">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="stack">
                  Create new stack template
                </h5>
              </div>
        <div class="modal-body">
        <div class="mb-3">
          <label
            for="exampleFormControlInput1"
            class="form-label"
            >Name</label
          >
          <input
            required
            type="text"
            class="form-control form-control-sm"
            id="name"
            v-model="stackTemplate.name"
            :style="{ width: inputWidth }"
          />
        </div>
        <div class="mb-3">
          <label
            for="exampleFormControlInput1"
            class="form-label"
            >Version</label
          >
          <input
            required
            type="text"
            class="form-control form-control-sm"
            id="name"
            v-model="stackTemplate.version"
            :style="{ width: inputWidth }"
          />
        </div>
        <div class="mb-3">
          <label
            for="exampleFormControlTextarea1"
            class="form-label"
            >Description</label
          >
          <textarea
            class="form-control"
            id="exampleFormControlTextarea1"
            rows="3"
            required
            v-model="stackTemplate.description"
          ></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="submit"
          data-bs-dismiss="modal"
          class="btn btn-primary btn-xs"
        >
          <i class="bi"></i>
          Create
        </button>
        <a
          href="#"
          data-bs-dismiss="modal"
          class="btn btn-primary btn-xs"
        >
          <i class="bi"></i>
          Cancel
        </a>
      </div>
    </div>
  </form>
</div>
</div>

      </div>
    </div>
  </div>
</div>

                </div>
              </div>
            </div>
          </table>
          <nav aria-label="Page navigation">
            <ul class="pagination justify-content-center">
              <!-- Botón anterior -->
              <li class="page-item" :class="{ disabled: currentPage === 1 }">
                <button class="page-link" @click="changePage(currentPage - 1)">
                  <i class="bi bi-chevron-left"></i>
                </button>
              </li>

              <!-- Primer página -->
              <li
                class="page-item"
                :class="{ active: currentPage === 1 }"
                v-if="totalPages > 0"
              >
                <button class="page-link" @click="changePage(1)">1</button>
              </li>

              <!-- Puntos suspensivos izquierda -->
              <li class="page-item" v-if="showLeftDots">
                <button class="page-link" disabled>…</button>
              </li>

              <!-- Páginas intermedias -->
              <li
                class="page-item"
                v-for="page in visiblePages"
                :key="page"
                v-if="page !== 1 && page !== totalPages"
                :class="{ active: page === currentPage }"
              >
                <button class="page-link" @click="changePage(page)">{{ page }}</button>
              </li>

              <!-- Puntos suspensivos derecha -->
              <li class="page-item" v-if="showRightDots">
                <button class="page-link" disabled>…</button>
              </li>

              <!-- Última página -->
              <li
                class="page-item"
                :class="{ active: currentPage === totalPages }"
                v-if="totalPages > 1"
              >
                <button class="page-link" @click="changePage(totalPages)">
                  {{ totalPages }}
                </button>
              </li>

              <!-- Botón siguiente -->
              <li class="page-item" :class="{ disabled: currentPage === totalPages }">
                <button class="page-link" @click="changePage(currentPage + 1)">
                  <i class="bi bi-chevron-right"></i>
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonBadge from "@/components/ArgonBadge.vue";
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  components: { ArgonBadge },
  data() {
    return {
      stacks: [],
      selectedNamespace: null,
      namespaces: [],
      searching: false,
      searchStackSelected: "",
      currentPage: 1,
      pageSize: 10,
      total: 0,
      snapshots: [],
      stackTemplate: {
        stack: Object,
        version: "",
        description: "",
        name: "",
      },
    };
  },
  computed: {
    totalPages() {
    return Math.ceil(this.total / this.pageSize);
  },
  visiblePages() {
    const total = this.totalPages;
    const current = this.currentPage;
    const delta = 2;
    const pages = [];

    for (let i = current - delta; i <= current + delta; i++) {
      if (i > 1 && i < total) {
        pages.push(i);
      }
    }

    return pages;
  },
  showLeftDots() {
    return this.currentPage - 2 > 2;
  },
  showRightDots() {
    return this.currentPage + 2 < this.totalPages - 1;
  },
  },
  mounted() {
    this.loadStacks();
  },
  methods: {
    async createTemplate(stack) {
      this.stackTemplate.stack = stack;
      try {
        const response = await this.$api.post(
          "/v1/template",
          this.stackTemplate
        );
        if (response.status === 200) {
          const message =
            response.data?.message || "template created successfully";
          toast.success(message);
          this.stackTemplate.stack = null;
          this.stackTemplate.version = "";
          this.stackTemplate.description = "";
          this.stackTemplate.name = "";
        } else {
          throw new Error("Unexpected response status");
        }
      } catch (error) {
        // Extraer el mensaje del backend
        const message =
          error.response?.data?.message || "Error creating template"; // Campo `message` del backend
        toast.error(message); // Mostrar el mensaje en el toast
        console.error("template creation error:", error);
      }
    },
    async createSnapshot(stack) {
      try {
        const response = await this.$api.post("/v1/snapshot", stack);
        if (response.status === 200) {
          const message =
            response.data?.message || "Snapshot created successfully";
          toast.success(message);
        } else {
          throw new Error("Unexpected response status");
        }
      } catch (error) {
        // Extraer el mensaje del backend
        const message =
          error.response?.data?.message || "Error creating snapshot"; // Campo `message` del backend
        toast.error(message); // Mostrar el mensaje en el toast
        console.error("Snapshot creation error:", error);
      }
    }, 

    async loadStacks() {
      try {
        const response = await this.$api.get(
          `/v1/stack?page=${this.currentPage}&pagesize=${this.pageSize}`
        );
        this.stacks = response.data.stacks || [];
        this.total = response.data.total || 0;
      } catch (error) {
        if (error.response?.status === 403) {
          this.$router.push("/error/403"); // Redirigir a Forbidden
        } else {
          const message =
            error.response?.data?.message || "Error fetching stacks";
          toast.error(message);
          console.error("Error loading stacks:", error);
        }
      }
    },

    async loadNamespaces() {
      try {
        const response = await this.$api.get(
          `/v1/namespace?all=1`
        );
        this.namespaces = response.data || [];
      } catch (error) {
        if (error.response?.status === 403) {
          this.$router.push("/error/403"); // Redirigir a Forbidden
        } else {
          const message =
            error.response?.data?.message || "Error fetching stacks";
          toast.error(message);
          console.error("Error loading stacks:", error);
        }
      }
    },    

    async changePage(page) {
      if (page < 1 || page > this.totalPages) {
        toast.warning("Invalid page number");
        return;
      }
      this.currentPage = page;
      this.loadStacks();
    },

    async searchStack(searchStack) {
      if (searchStack == "") {
        this.searching = false;
        this.loadStacks();
      } else {
      this.stacks = [];
      this.searching = false;
      this.$api
        .get(
          `/v1/stack?page=${this.currentPage}&pagesize=${this.pageSize}&searchstack=${searchStack}`
        )
        .then((response) => {
          
          this.stacks = response.data.stacks;
          this.total = response.data.total;
          this.searching = true;
        })
        .catch((error) => {
          console.error("Error fetching stack:", error);
        });
      }
    }, 

    async updateStack(stack) {
      try {
        const response = await this.$api.put("/v1/stack", stack); // Corrigiendo método a PUT si es una actualización
        if (response.status === 200) {
          toast.success("Stack updated successfully");
          this.loadStacks(); // Recargar stacks actualizados
        } else {
          throw new Error("Unexpected response status");
        }
      } catch (error) {
        const message = error.response?.data?.message || "Error updating stack";
        toast.error(message);
        console.error("Error updating stack:", error);
      }
    },
  },
};
</script>
